// third-party
import { FormattedMessage } from 'react-intl';

// type
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - PAGES ||============================== //

const orders: NavItemType = {
  id: 'orders',
  title: <FormattedMessage id="orders" />,
  type: 'item',
  url: '/',
  target: false
};

export default orders;
